import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const ProgesoCircular = (props) => {
  const { alineado, ...restProps } = props;

  return (
    <Box sx={{ position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        }}
        size={80}
        thickness={4}
        value={100}
        {...restProps}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) => (theme.palette.mode === 'light' ? '#EE805D' : 'grey'),
          animationDuration: '650ms',
          position: 'absolute',
          left: 0,
          strokeLinecap: 'round',
        }}
        size={80}
        thickness={4}
        {...restProps}
      />
    </Box>
  );
}

// Definir el componente estilizado solo cuando alineado es true
const PosicionCarga = styled(ProgesoCircular)(({ alineado }) => ({
  marginTop:'1%',
  marginLeft: alineado ? '45%' : 'auto',
  '@media (max-width: 576px)': {
    marginLeft: alineado ? '35%' : 'auto',
  }
}));

export default PosicionCarga;

